export default __webpack_public_path__ + "img/hour-title-1c5ab223.png";